import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { type ReactElement, useEffect, useRef, useState } from 'react';
import { Image } from '~/components/Image/Image';
type ImageGridImage = {
  src: string;
  width: number;
  height: number;
  credit?: string | null;
};
type SizedImage = [ImageGridImage, number];
type ImageGridProps = {
  images: ImageGridImage[];
  margin?: number;
  initialWidth?: number;
  rowHeight: number;
};
const ImageGrid = t0 => {
  const $ = _c(14);
  const {
    images,
    margin: t1,
    initialWidth: t2,
    rowHeight
  } = t0;
  const margin = t1 === undefined ? 0 : t1;
  const initialWidth = t2 === undefined ? 0 : t2;
  const container = useRef(null);
  const [width, setWidth] = useState(initialWidth);
  const t = useTranslations("journey");
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      if (container.current) {
        setWidth(container.current.offsetWidth);
      }
    };
    t4 = [];
    $[0] = t3;
    $[1] = t4;
  } else {
    t3 = $[0];
    t4 = $[1];
  }
  useEffect(t3, t4);
  let t5;
  if ($[2] !== margin || $[3] !== t || $[4] !== width) {
    t5 = (image, totalIndex, rowIndex, row, imageWidth) => {
      const calculatedRowHeight = width / imageWidth;
      const imageStyle = {
        height: `${calculatedRowHeight}px`,
        width: `${calculatedRowHeight * image[1] - margin}px`,
        marginRight: rowIndex === row.length - 1 ? 0 : `${margin}px`
      };
      return <div style={imageStyle} data-index={totalIndex} key={`img_grid_${image[0].src}`}><Image src={image[0].src} alt="" fill={true} sizes="(min-width: 1024px) 33vw, (min-width: 768px) 50vw, 100vw" rounded={true} label={image[0].credit ? t("photo_credit", {
          credit: image[0].credit
        }) : undefined} /></div>;
    };
    $[2] = margin;
    $[3] = t;
    $[4] = width;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const imageDataToImgTag = t5;
  let t6;
  if ($[6] !== imageDataToImgTag || $[7] !== images || $[8] !== margin || $[9] !== rowHeight || $[10] !== width) {
    t6 = () => {
      const allRows = [];
      let row_0 = [];
      let widthSoFar = 0;
      const minAspectRatio = width / rowHeight;
      for (let i = 0; i < images.length; i++) {
        const image_0 = images[i];
        let ratio = image_0.width / image_0.height;
        if (widthSoFar <= minAspectRatio && i !== images.length - 1) {
          ratio = ratio + margin / image_0.height;
          row_0.push([image_0, ratio]);
          widthSoFar = widthSoFar + ratio;
        } else {
          if (i === images.length - 1) {
            row_0.push([image_0, ratio]);
            widthSoFar = widthSoFar + ratio;
          }
          const imageElements = [];
          for (let j = 0; j < row_0.length; j++) {
            imageElements.push(imageDataToImgTag(row_0[j], i - row_0.length + j, j, row_0, widthSoFar));
          }
          allRows.push(imageElements);
          row_0 = [[image_0, ratio]];
          widthSoFar = ratio;
        }
      }
      const divStyle = {
        display: "flex",
        marginBottom: `${margin}px`
      };
      return allRows.map((row_1, index) => <div style={divStyle} key={`row_${index}`}>{row_1}</div>);
    };
    $[6] = imageDataToImgTag;
    $[7] = images;
    $[8] = margin;
    $[9] = rowHeight;
    $[10] = width;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const buildRows = t6;
  let t7;
  if ($[12] !== buildRows) {
    t7 = <div className="w-full" ref={container}>{buildRows()}</div>;
    $[12] = buildRows;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};
export default ImageGrid;